import { useState } from "react";
import { ResidentDto } from "../../dtos/ResidentDto";
import { Stack } from '@mui/material';
import { SearchBhpEmployeeContractor } from '../VillageWifi/SearchBhpEmployeeContractor';
import { ManageCardholderCompetencyDialog } from "./ManageCardholderCompetencyDialog";
import { Asset } from "../../data/Asset";
import { CheckHealth } from "../Maintenance/components/CheckHealth";


export const GymCompetency: React.FC = ( ) => {

    const [ manageCardholderCompetencyDialogOpen, setManageCardholderCompetencyDialogOpen ] = useState< boolean >( false );
    const [ manageCardholderCompetencyDialogOpenCounter, setManageCardholderCompetencyDialogOpenCounter ] = useState< number >( 0 );
    const [ resident, setResident ] = useState<ResidentDto>( );


    const handleSelectResident = async ( resident : ResidentDto | undefined ) => { 
        
        setResident( resident ); 
        
        if( resident ) {
            
            setManageCardholderCompetencyDialogOpenCounter( counter => ++counter );
            setManageCardholderCompetencyDialogOpen( true );

        }
    
    };


    const handleManageCardholderCompetencyDialogClose = ( ) => setManageCardholderCompetencyDialogOpen( false );

    
    return (
 
        <>
            <CheckHealth />

            <Stack justifyContent="center" spacing={ 1 } sx={{ alignItems :"center", marginTop: '10px' }}>
                
                <SearchBhpEmployeeContractor assets={[ /*Asset.Niw,*/ Asset.Waio ]} onSelectResident={ handleSelectResident } />

            </Stack>

            {
                resident
                     &&
                <ManageCardholderCompetencyDialog 
                    competency={ "Gym" } 
                    dialogOpen={ manageCardholderCompetencyDialogOpen }
                    dialogOpenCounter={ manageCardholderCompetencyDialogOpenCounter }
                    onClose={ handleManageCardholderCompetencyDialogClose } 
                    resident={ resident } 
                    
                />
            }

        </>

    );
  
};